import { Link } from '@/types/link';
import { Response } from '@/types/response';
import { api } from '@/utils/axios';

export const GetLinks = async (): Promise<Response<Link[]>> => {
  const res = await api.get('/app-web/links');
  return res.data;
};
